var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('skrg_overview_hdr',{ref:"skrg_overview_hdr",staticClass:"mb-2",on:{"updateSelection":_vm.updateSelection}}),_c('skrg_overview_lst',{ref:"skrg_overview_lst"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }